<div class="row m-0 p-0">
  <div class="col-auto m-0 p-0">
    <div class="user-img-spacer"></div>
  </div>
  <div class="col m-0 p-0 ps-3">
    <app-dea-timetable [teacherId]="teacherId" [startLoading]="startLoading"></app-dea-timetable>
  </div>
</div>
